import DateTimeCell from 'pages/event-list-page/event-table-cells/date-time-cell';
import { Column } from 'react-table';
import { DateColumnFilter, SelectColumnFilter, SelectOptionType } from 'utils/react-table';
import JsonFormatCell from 'pages/calendar/event-history-page/components/json-format-cell';
import { SortingType } from 'components/base-table/dto';
import { MessageStatusOptions } from 'common/dto-types/message-dto';
import MessageStatusCell from '../components/message-status-cell';

const operationTypesOptions: SelectOptionType[] = [
    { label: 'Create', value: 'Create' },
    { label: 'Update', value: 'Update' },
    { label: 'Update Status', value: 'UpdateStatus' },
    { label: 'Delete', value: 'Delete' },
];

const MessageHistoryTableColumnConfig: Column[] = [
    {
        Header: 'Timestamp UTC',
        accessor: 'timestampUTC',
        disableSortBy: false,
        Filter: DateColumnFilter,
        Cell: DateTimeCell,
    },
    {
        Header: 'Message ID',
        accessor: 'messageId',
        disableSortBy: false,
    },
    {
        Header: 'User',
        accessor: 'userTrigram',
    },
    {
        Header: 'Operation Type',
        accessor: 'operationType',
        Filter: (props) => <SelectColumnFilter {...props} options={operationTypesOptions} />,
    },
    {
        Header: 'Message Status',
        accessor: 'messageStatus',
        Filter: (props) => <SelectColumnFilter {...props} options={MessageStatusOptions} />,
        Cell: MessageStatusCell,
    },
    {
        Header: 'Log Data',
        accessor: 'changeData',
        disableFilters: true,
        Cell: JsonFormatCell,
    },
];

export default MessageHistoryTableColumnConfig;

export const DefaultVisibleMessageHistoryColumns = [
    'timestampUTC',
    'messageId',
    'userTrigram',
    'messageStatus',
    'operationType',
    'changeData',
];

export const SearchableMessageHistoryTableColumnConfig = ['messageId', 'userTrigram'];
export const DefaultMessageHistoryTableColumnIdToSortBy = 'timestampUTC';
export const DefaultMessageHistoryTableSortingType = SortingType.Descending;
